import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import { RenderFn } from 'src/types/widgets';
import normalizeWidgetInput from 'src/common/normalizeWidgetInput';
import widgetDefinition from './LeadershipAssessment.widget.js';
import LeadershipAssessment from './components/LeaderAssesssment';
import configuration from './data/index';
import ReactGA from 'react-ga4';
import { GATags } from 'src/common/utils/GATags';

import 'carbon-components/css/carbon-components.min.css';

ReactGA.initialize(GATags.LEADERSHIP_ASSESSMENT);

const render: RenderFn = async function (instanceId, langCode, origin, cb) {
  const { element, locale, messages } = await normalizeWidgetInput(
    instanceId,
    langCode,
    widgetDefinition,
  );

  if (!element || !locale) {
    return;
  }

  ReactDOM.render(
    <React.StrictMode>
      <IntlProvider locale={locale} messages={messages}>
        <LeadershipAssessment configuration={configuration} />
      </IntlProvider>
    </React.StrictMode>,
    element,
    () => cb(element),
  );
};

export default render;
